import React, { Fragment as F } from 'react'
import c from 'classnames'
import isEmpty from 'lodash/isEmpty'
import { Link } from 'redux-little-router'
import { connect } from 'react-redux'
import {
  addToPageState,
  removeFromPageState,
  toggleQueryValue,
} from 'actions/pageStateActions'

import Icon from 'discada/dist/Icon'
import {
  getShortUserName,
  getPermissions,
  hasWrite,
} from 'selectors/authSelectors'
import { getRooftopOptions } from 'selectors/authSelectors'

import { signOut } from 'actions/authActions'

import { createNavFilter } from 'pages/routes'


export class NavbarMenuUnconnected extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      open: false,
    }
  }

  render() {
    let { title, icon, menu, onClicks, scrub } = this.props
    return (
      <div className="navbar-item has-dropdown is-hoverable">
        <NavbarLink
          title={title}
          icon={icon}
          noFollow
          className="navbar-link"
        />

        <div className="navbar-dropdown is-boxed is-right">
          {Object.keys(menu).filter(createNavFilter(menu, this.props)).map((k, i) => {
            return isEmpty(k) ? (
              <hr className="navbar-divider" key={i} />
            ) : (
              <NavbarLink
                key={i}
                {...menu[k]}
                onClick={
                  menu[k].onClick ? () => menu[k].onClick(onClicks) : null
                }
                pathname={k}
                scrub={scrub}
              />
            )
          })}
        </div>
      </div>
    )
  }
}


function mapStateToPropsMenu(state, op) {
  return {
    ...op,
    rooftopOptions: getRooftopOptions(state)
  }
}

const NavbarMenu = connect(
  mapStateToPropsMenu,
  { },
)(NavbarMenuUnconnected)

//////////////////////////////////////////////

export function NavbarLinkPreso(props) {
  let {
      title,
      href,
      pathname,
      query,
      icon,
      className,
      menu,
      children,
      scrub = k => k,
      canDo,
      onClick = () => {},
      signOut,
      noFollow,
      external,
      userName,
      toggleQueryValue,
      addToPageState,
      removeFromPageState,
    } = props,
    body = children || (
      <F>
        {icon && <Icon icon={icon} />}
        {typeof title === 'function' ? title({ userName }) : title}
      </F>
    )

  if (!canDo) return null // must have all permissions as marked in routes.js to appear

  if (menu)
    return (
      <NavbarMenu
        {...props}
        onClicks={{
          addToPageState,
          removeFromPageState,
          toggleQueryValue,
          signOut,
        }}
      />
    )

  if (noFollow) {
    return (
      <span
        onClick={onClick}
        className={c('navbar-item', 'no-link', className)}
      >
        {body}
      </span>
    )
  }

  if (external) {
    return (
      <a
        href={href || pathname}
        target="_blank"
        rel="noopener noreferrer"
        className={c('navbar-item', className)}
      >
        {body}
      </a>
    )
  }

  return (
    <Link
      className={c('navbar-item', className)}
      href={href || { pathname: scrub(pathname), query }}
      activeProps={{ className: 'navbar-item is-active' }}
      onClick={onClick}
    >
      {body}
    </Link>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    rootopPermissions: getPermissions(state),
    canDo: !op.permissions || op.permissions.every(p => hasWrite(state, p)),
    userName: getShortUserName(state),
    rooftopOptions: getRooftopOptions(state)
  }
}

export const NavbarLink = connect(
  mapStateToProps,
  { signOut, addToPageState, removeFromPageState, toggleQueryValue },
)(NavbarLinkPreso)
